import React from 'react';
import FormControlLabel, {FormControlLabelProps} from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import MuiCheckBox from '@material-ui/core/Checkbox';
import {FieldValues, useController} from 'react-hook-form';
import {UseControllerProps} from './types';

export type CheckBoxProps<FormValues extends FieldValues = FieldValues> = UseControllerProps<
    FormControlLabelProps,
    FormValues
>;

function CheckBox<FormValues>({
    name,
    rules,
    control,
    defaultValue = false,
    shouldUnregister = true,
    ...props
}: React.PropsWithChildren<CheckBoxProps<FormValues>>) {
    const {
        field: {onChange, onBlur, value, name: fieldName, ref},
        fieldState: {invalid, error}
    } = useController({control, name, rules, defaultValue, shouldUnregister});

    return (
        <>
            <FormControlLabel
                {...props}
                name={fieldName}
                onBlur={onBlur}
                onChange={onChange}
                checked={!!value}
                innerRef={ref}
                control={<MuiCheckBox color="primary" />}
            />
            <FormHelperText error={invalid}>{error && error.message}</FormHelperText>
        </>
    );
}

export default CheckBox;
